import { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, LANGUAGE_NAMES, setLanguage } from '@/shared/i18n';
import type { Language } from '@/shared/i18n';

/** Sits beside the theme switcher: both are choices about this device, not this account. */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const current = i18n.language as Language;

  return (
    <>
      <Tooltip title={t('language.label')}>
        <IconButton
          size="small"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          aria-label={t('language.label')}
        >
          <TranslateIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {LANGUAGES.map((language) => (
          <MenuItem
            key={language}
            selected={language === current}
            onClick={() => {
              setLanguage(language);
              setAnchorEl(null);
            }}
          >
            {LANGUAGE_NAMES[language]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
